export enum QUERY_PARAMS {
  FLOW = 'flow',
  CLAIM_ID = 'claim-id',
}

export enum FLOWS {
  CLAIM_FORM = 'claim-form',
}

export enum PATHS {
  BIG_WINNER = '/big-winner',
  CLAIM_FORM = '/claim-form',
  CONFIRMATION = '/confirm',
  NEW_APPOINTMENT = '/create',
  DAMAGED_TICKET = '/damaged',
  DELETE_APPOINTMENT = '/delete',
  EDIT_APPOINTMENT = '/edit',
  MANY_TICKETS = '/tickets',
  REGULAR_TICKET = '/regular-ticket',
  RESCHEDULE_APPOINTMENT = '/reschedule',
  UNKNOWN = '/unknown',
}
